var testi_carousels = document.querySelectorAll(".testimonials--body.swiper-container");

testi_carousels.forEach((carou) => {
  new Swiper(carou, {
    // Optional parameters
    direction: "horizontal",
    slidesPerView: 2.4,
    speed: 1000,
    spaceBetween: 30,
    breakpoints: {
      300: {
        slidesPerView: 1.4,
        spaceBetween: 10,
      },
      800: {
        slidesPerView: 2,
      },
      1300: {
        slidesPerView: 2,
      },
      1441: {
        slidesPerView: 2.3,
      }
    },

    // Navigation arrows
    navigation: {
      nextEl: `.swiper-button-next-${carou.getAttribute("data-id")}`,
      prevEl: `.swiper-button-prev-${carou.getAttribute("data-id")}`,
    },
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
});
